import { createProgress } from "lib/progress";

export const { useProgress, ...Progress } = createProgress();
